import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EditingBoxConfigItem } from '@shared/components/editing-box/editing-box-overlay.config';
import { EditingBoxStreamService } from '@shared/components/editing-box/editing-box-stream.service';
import { EditingBoxService } from '@shared/components/editing-box/editing-box.service';
import { isMasked } from '@shared/utils/helpers/sanitizers';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'miq-array-text',
  templateUrl: './array-text.component.html',
  styleUrls: ['./array-text.component.scss'],
  standalone: false,
})
export class ArrayTextComponent implements OnInit, OnChanges {
  @Input()
  currentValue: any;
  @Input()
  disabled: boolean;
  @Input()
  column: any;
  @Input()
  record: any;
  @Input()
  isNewRecord: Boolean;

  @Output()
  currentValueChange = new EventEmitter<any>();

  // This variable will contain the final value to be displayed in the input
  public displayValue: string[];
  private field: string;

  isMaskedValue = false;

  ngOnInit(): void {
    this.isMaskedValue = isMasked(this.currentValue);
    this.disabled = this.isMaskedValue ? this.isMaskedValue : this.disabled;
    this.field = this.column.field.split('/')[1];

    this.recordChangeStream.arrayAttributesStream$
      .pipe(
        untilDestroyed(this),
        filter(data => !!data)
      )
      .subscribe(res => {
        this.displayValue = this.processDisplayValue(res);
        this.currentValueChange.emit(this.column.valueSetter ? this.column.valueSetter(res) : res);
      });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    const { currentValue } = simpleChanges;
    if (currentValue) {
      this.displayValue = this.processDisplayValue(this.currentValue);
    }
  }

  // Since the input and output values for `currentValue` are not consistent,
  // when the object is an array of objects, try to dig the values, otherwise doesnt do anything
  private processDisplayValue(values: any[]): string[] {
    return (values || [])
      .map(rec => {
        let value = rec;
        if (typeof rec !== 'string') {
          value = rec[this.field];
        }
        return value;
      })
      .filter(Boolean);
  }

  constructor(
    private editingBoxService: EditingBoxService,
    private recordChangeStream: EditingBoxStreamService
  ) {}

  click(event, recordDetail) {
    const { field } = recordDetail;
    if ((field && field === 'property_apn_number/property_apn_number') || field === 'target_geography.city/city_desc') {
      if (
        recordDetail.parent.hasOwnProperty('update') ||
        recordDetail.parent.hasOwnProperty('create') ||
        this.isNewRecord
      ) {
        const edpUpdateConf: EditingBoxConfigItem = {
          updatableFields: [field, `${field}_uom_desc`],
        };
        this.editingBoxService.openEditingBoxFromClick(event, { edpUpdateConf }, this.record);
      }
    }
  }
}
